import { render, staticRenderFns } from "./image_upload_and_editor.vue?vue&type=template&id=e23f2a20&"
import script from "./image_upload_and_editor.vue?vue&type=script&lang=js&"
export * from "./image_upload_and_editor.vue?vue&type=script&lang=js&"
import style0 from "./image_upload_and_editor.vue?vue&type=style&index=0&id=e23f2a20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports